import types from "../actions/types";

export const typeLoginSnsAction = () => ({
  type: types.TYPE_LOGIN_SNS,
});
